import React, { useContext, useEffect } from 'react';
import useOnChange from '../../../../hooks/useChange'
import { ContextBuilder } from '../../../../context/builder/reducers';
import Input from '../Input';
import TextArea from '../TextArea';

const VacancyDescription = (props) => {
    const { state, dispatch } = useContext(ContextBuilder);
    const onChange = useOnChange(props.index);
    useEffect(() => {
        if (!props.content) {
            const data = state.data;
            data.value[props.index].content = {
                column1: {
                    title: '',
                    elements: [
                        { content: '' },
                        { content: '' },
                        { content: '' },
                        { content: '' },
                        { content: '' },
                        { content: '' },
                        { content: '' }
                    ]
                }, column2: {
                    title: '',
                    elements: [
                        { content: '' },
                        { content: '' },
                        { content: '' },
                        { content: '' },
                        { content: '' },
                        { content: '' },
                        { content: '' }
                    ]
                }
            };
            dispatch({ type: 'data', payload: { data: data } });
        }
    });

    const column1 = props.content.column1 ||
        {
            title: '',
            elements: [
                { content: '' },
                { content: '' },
                { content: '' },
                { content: '' },
                { content: '' },
                { content: '' },
                { content: '' }
            ]
        }

    const column2 = props.content.column2 ||
        {
            title: '',
            elements: [
                { content: '' },
                { content: '' },
                { content: '' },
                { content: '' },
                { content: '' },
                { content: '' },
                { content: '' }
            ]
        }

    return (
        <div className="about-us">
            <h2>Vacancy text block</h2>
            <div className="row">
                <div className="col-6">
                    <div className="form-group">
                        <label>Title</label>
                        <Input name="column1.title" value={column1.title|| ''}
                               onChange={onChange}/>
                    </div>
                    <div className="form-group">
                        <label>Item 1</label>
                        <Input name="column1.elements.0.content" value={column1.elements[0].content || ''}
                               onChange={onChange}/>
                    </div>
                    <div className="form-group">
                        <label>Item 2</label>
                        <Input name="column1.elements.1.content" value={column1.elements[1].content || ''}
                               onChange={onChange}/>
                    </div>
                    <div className="form-group">
                        <label>Item 3</label>
                        <Input name="column1.elements.2.content" value={column1.elements[2].content || ''}
                               onChange={onChange}/>
                    </div>
                    <div className="form-group">
                        <label>Item 4</label>
                        <Input name="column1.elements.3.content" value={column1.elements[3].content || ''}
                               onChange={onChange}/>
                    </div>
                    <div className="form-group">
                        <label>Item 5</label>
                        <Input name="column1.elements.4.content" value={column1.elements[4].content || ''}
                               onChange={onChange}/>
                    </div>
                    <div className="form-group">
                        <label>Item 6</label>
                        <Input name="column1.elements.5.content" value={column1.elements[5].content || ''}
                               onChange={onChange}/>
                    </div>
                    <div className="form-group">
                        <label>Item 7</label>
                        <Input name="column1.elements.6.content" value={column1.elements[6].content || ''}
                               onChange={onChange}/>
                    </div>
                </div>
                <div className="col-6">
                    <div className="form-group">
                        <label>Title</label>
                        <Input name="column2.title" value={column2.title|| ''}
                               onChange={onChange}/>
                    </div>
                    <div className="form-group">
                        <label>Item 1</label>
                        <Input name="column2.elements.0.content" value={column2.elements[0].content || ''}
                               onChange={onChange}/>
                    </div>
                    <div className="form-group">
                        <label>Item 2</label>
                        <Input name="column2.elements.1.content" value={column2.elements[1].content || ''}
                               onChange={onChange}/>
                    </div>
                    <div className="form-group">
                        <label>Item 3</label>
                        <Input name="column2.elements.2.content" value={column2.elements[2].content || ''}
                               onChange={onChange}/>
                    </div>
                    <div className="form-group">
                        <label>Item 4</label>
                        <Input name="column2.elements.3.content" value={column2.elements[3].content || ''}
                               onChange={onChange}/>
                    </div>
                    <div className="form-group">
                        <label>Item 5</label>
                        <Input name="column2.elements.4.content" value={column2.elements[4].content || ''}
                               onChange={onChange}/>
                    </div>
                    <div className="form-group">
                        <label>Item 6</label>
                        <Input name="column2.elements.5.content" value={column2.elements[5].content || ''}
                               onChange={onChange}/>
                    </div>
                    <div className="form-group">
                        <label>Item 7</label>
                        <Input name="column2.elements.6.content" value={column2.elements[6].content || ''}
                               onChange={onChange}/>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default VacancyDescription;
